export default {
      id: "social-small-linkedin-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#social-small-linkedin",
      toString: function () {
        return this.url;
      }
    }